(function ($) {
  "use strict";

  $(function () {

    $(document).on("click", function (event) {
      const $menuContainer = $(".qld__main-nav");

      // If the click is outside the nav menu
      if (
        !$menuContainer.is(event.target) &&
        $menuContainer.has(event.target).length === 0
      ) {
        $menuContainer.find(".collapse.show").each(function () {
          const collapseInstance = bootstrap.Collapse.getInstance(this);
          if (collapseInstance) {
            collapseInstance.hide();
          }
        });
      }
    });

    // Open main nav mobile menu
    $(".js-main-nav-toggle").on("click", function () {
      const $mainNavContent = $(".qld__main-nav__content");
      const isClosed = $mainNavContent.hasClass(
        "qld__main-nav__content--closed"
      );
      if (isClosed) {
        $mainNavContent
          .removeClass("qld__main-nav__content--closed")
          .addClass("qld__main-nav__content--open");
        $("html, body").addClass("qld__main-nav__open");
      }
    });

    // Close main nav mobile menu
    $(".js-main-nav-close, .qld__main-nav__overlay").on("click", function () {
      const $mainNavContent = $(".qld__main-nav__content");
      const isOpen = $mainNavContent.hasClass("qld__main-nav__content--open");
      if (isOpen) {
        $mainNavContent
          .removeClass("qld__main-nav__content--open")
          .addClass("qld__main-nav__content--closed");
        $("html, body").removeClass("qld__main-nav__open");
      }
    });

    $(".qld__main-nav__sub-item.is-current")
      .parents(".qld__main-nav__item ")
      .addClass("active");
  });
})(jQuery);
